import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareOnboardingRoute: InvariantJiraRoute = {
	name: 'software-onboarding',
	path: '/welcome/software',
	exact: true,
};
